import React, {PropTypes} from 'react';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';
import ImageUpload from '../../form/ImageUpload/ImageUpload';
import PartnerBannerFormTable from './PartnerBannerFormTable/PartnerBannerFormTable';
import PartnerBannerLinkType from './PartnerBannerLinkType';
import LoadingSpinner from '../../LoadingSpinner';
import RaisedButton from 'material-ui/RaisedButton';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import {Container, Row, Col} from 'react-grid-system';
import config from 'config';

const styles = {
  bannerWrapper: {
    marginTop: 15,
    marginBottom: 15
  },
  banner: {
    style: {
      textAlign: 'center',
      fontSize: '20px',
      fontWeight: '100',
      lineHeight: '27px',
      minHeight: 35
    }
  },
  buttonLink: {
    style: {
      float: 'right',
      backgroundColor: '#911630',
      border: 0,
      color: 'white',
      borderRadius: '2px',
      height: '30px',
      width: '25%',
      fontSize: '12px',
      fontWeight: 'lighter',
      position: 'relative',
      top: '1px',
      outline: 'none',
      cursor: 'pointer'
    }
  },
  bannerLinkInternal: {
    style: {
      width: '75%',
      position: 'relative',
      boxSizing: 'border-box',
      outline: 'none',
      height: '30px',
      padding: '0 5px',
      fontSize: '14px',
      lineHeight: '30px'
    }
  },
  bannerLinkExternal: {
    style: {
      width: '100%',
      position: 'relative',
      boxSizing: 'border-box',
      outline: 'none',
      height: '30px',
      padding: '0 5px',
      fontSize: '14px',
      lineHeight: '30px'
    }
  },
  noBanner: {
    style: {
      textAlign: 'center',
      fontSize: '20px',
      fontWeight: '100'
    }
  },
  tip: {
    fontSize: 12,
    textAlign: 'center'
  }
};

class PartnerBannerForm extends React.Component {

  state = {
    displayModal: false,
    externalLink: {}
  };

  publish = () => {
    let {club_id, save} = this.props;
    save(this.props.bannerList, this.props.values, club_id);
  };

  confirmTodeleteBanner = () => {
    if (confirm('Delete this Banner?')) {
      return true;
    }
    return false;
  };

  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    error: PropTypes.string,
    resetForm: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    load: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired,
    create: PropTypes.func.isRequired,
    update: PropTypes.func.isRequired,
    updateUrl: PropTypes.func.isRequired,
    updateLinkType: PropTypes.func.isRequired,
    updateBannerPromoLink: PropTypes.func.isRequired,
    deleteBanner: PropTypes.func.isRequired,
    bannerList: PropTypes.array
  };

  onChangeBanner(key, banner, promo) {
    let {updateBannerPromoLink} = this.props;
    updateBannerPromoLink(key, banner, promo);
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  componentDidMount() {
    const {router} = this.context;
    const {route} = this.props;
    router.setRouteLeaveHook(route, this.routerWillLeave.bind(this));
  }

  routerWillLeave() {
    if (this.props.dirty) {
      return 'Do you want to leave this page? Unsaved data will be lost.';
    }
  }

  validateUrl(value, key) {
    const url = 'http://';
    let {updateUrl} = this.props;

    if (value.length || value.length > 7) {
      if (!/^(http)s?:\/\//i.test(value))
        if (/[A-Za-z0-9]{3,}:\/\//.test(value))
          value = url;
        else
          value = url + value;
      value = value.replace(/^(http)s?:\/\/http:\//i, url);
    } else {
      value = url;
    }
    updateUrl(value, key);
  }

  componentWillMount() {
    let {club_id, load} = this.props;
    load(club_id);
  }

  _doesModuleExist(type){
    let {modules} = this.props;
    return modules.some((m)=>(m.type === type));
  }

  render() {
    let {fields, create, update, updateLinkType, deleteBanner, bannerList, club_id, loading, modules} = this.props;
    return (
      <form style={{margin: '35px 20px'}}>
        <LoggedAppBar
          isStatic={true}
          title='BANNERS'
        />
        <LoadingSpinner show={loading}>
          <Container style={{marginLeft: 0}}>
            <Row>
              <Col md={3} xs={12}>
                <Row>
                  <Col md={12} style={{marginBottom: 15}}>
                    <ImageUpload
                      styles={{paddingTop: 0, margin: 0, height: '80px', width: 'auto'}}
                      crop={config.partnerBannerCrop}
                      imageWidth='auto'
                      imageHeight='80px'
                      textSize={10}
                      displayCroppedItem={false}
                      onChange={async (image) => {
                        create(image, club_id);
                      }}
                    />
                    <div style={styles.tip}>{'(Minimum size 1242 x 230 px)'}</div>
                  </Col>
                </Row>
                <Row style={styles.bannerWrapper}>
                  {
                    bannerList.map((banner, key)=> (
                      <Col md={12} key={key} style={{marginBottom: 30}}>
                        <div {...styles.banner}>
                          <ImageUpload
                            styles={{paddingTop: 0, margin: 0, height: '80px', width: 'auto'}}
                            crop={config.partnerBannerCrop}
                            imageWidth='auto'
                            imageHeight='80px'
                            paddingTop='0'
                            marginBottom='7px'
                            iconView={{position: 'absolute', left: 0}}
                            displayPosition='flex-end'
                            value={banner.image || banner.photo}
                            onChange={async (image) => {
                            if(image){
                              update(image, key, banner, club_id);
                            } else if(image === null) {
                              if(this.confirmTodeleteBanner()){
                                deleteBanner(key, banner.id, club_id);
                              }
                            }
                          }}
                          />
                          {this._doesModuleExist('shop') ?
                            (
                              banner.reference ? (
                                banner.reference.type === 'external'
                                  ? (
                                  <input
                                    {...styles.bannerLinkExternal}
                                    type='url'
                                    value={banner.reference.uri}
                                    placeholder='http://example.com/'
                                    onChange={(e) => {this.validateUrl(e.target.value, key)}}
                                  />
                                )
                                  : (
                                  <PartnerBannerLinkType styles={styles} bannner={banner}
                                                         onChange={(promo) => this.onChangeBanner(key, banner, promo)}/>
                                )
                              ) : ''
                            ) : null
                          }
                        </div>
                        {this._doesModuleExist('shop') ?
                          (<RadioButtonGroup name='shipSpeed'
                                            defaultSelected={banner.reference ? banner.reference.type : 'external'}
                                            style={{display: 'flex', flexDirection: 'row',justifyContent: 'space-around'}}>
                            <RadioButton
                              style={{width: 'auto'}}
                              label='Link'
                              labelStyle={{width: 'auto', lineHeight: '20px', fontSize: '15px'}}
                              iconStyle={{marginRight: 5, width: 20, height: 20}}
                              value='external'
                              onClick={()=>{updateLinkType('external', key)}}
                            />
                            <RadioButton
                              style={{width: 'auto'}}
                              label='Shop Item'
                              labelStyle={{width: 'auto', lineHeight: '20px', fontSize: '15px'}}
                              iconStyle={{marginRight: 5, width: 20, height: 20}}
                              value='promo'
                              onClick={()=>{updateLinkType('promo', key)}}
                            />
                          </RadioButtonGroup>)
                          : null
                        }
                      </Col>
                    ))
                  }
                  <Col md={12} style={{marginTop: 15}}>
                    <div {...styles.noBanner}>NO BANNER</div>
                  </Col>
                </Row>
              </Col>
              <Col md={9} xs={12}>
                <PartnerBannerFormTable {...fields} bannerList={bannerList} modules={modules}/>
              </Col>
            </Row>
            <Row>
              <Col md={3} xs={12}>
                <RaisedButton secondary={false}
                              onClick={this.publish}
                              style={{display: 'block'}}
                              label='SAVE AND PUBLISH'/>
              </Col>
            </Row>
          </Container>
        </LoadingSpinner>
      </form>
    );
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: 'CLEAN_PROPS'
    });
  }
}

export default PartnerBannerForm;





// WEBPACK FOOTER //
// ./src/components/Partner/PartnerBannerForm/PartnerBannerForm.jsx